import React, { useRef } from 'react';
import './error.css';
import { KID_1 } from '../../utils/constants/images';
import { useNavigate } from 'react-router-dom';
import BestStartButton from '../../components/button';

function SomethingWrongPage(props) {
    const navigate = useNavigate();
    const didNavigateRef = useRef(false);

    const handleBack = () => {
        // protect against multiple clicks / multiple event firings from the styled button
        if (didNavigateRef.current) return;
        didNavigateRef.current = true;

        // First notify the ErrorBoundary to reset its error state if provided
        if (typeof props?.onReset === 'function') {
            try { props.onReset(); } catch (e) { /* ignore */ }
        }

        // Delay navigation a tick so the ErrorBoundary can clear and allow the target
        // route to mount cleanly. This reduces races with SignalR/other services.
        setTimeout(() => {
            try {
                if (window.history.length > 1) {
                    navigate(-1);
                } else {
                    navigate('/');
                }
            } catch (e) {
                window.location.href = '/';
            }
        }, 50);
    };

    return (
        <div className="error-container">
            <img src={KID_1} alt="Error" className="error-image" />
            <h1>Something went wrong</h1>
            <p>An error occured on this page. please contact Beststart helpdesk</p>
            <div className="error-actions">
                <BestStartButton text="Go back" color="blue" onClick={handleBack} data-testid="error-back" />
            </div>
        </div>
    );
}

export default SomethingWrongPage;